import { useContext } from "react";
import dynamic from "next/dynamic";
import { AuthProvider } from "pages";
import { FEATURE_TOGGLES } from "constant";
import DefaultDockablePortal from "components/ai-chat/DockablePortal";

const McpDockablePortal = dynamic(() => import("components/ai-chat copy/DockablePortal"), {
  ssr: false,
});

const AIChatPortal = () => {
  const authDetail = useContext(AuthProvider);
  const aiChatMcpEnabled = !!authDetail?.toggles?.[FEATURE_TOGGLES.AI_CHAT_MCP];
  const DockablePortal = aiChatMcpEnabled ? McpDockablePortal : DefaultDockablePortal;

  return <DockablePortal />;
};

export default AIChatPortal;
